'use strict';
import addProductToCart from './product/addToCart';
import page from '../page';
import login from '../login';
import util from '../util';
import account from './account';
import minicart from '../minicart';
import productTile from '../product-tile';
import search from '../pages/search';
import toast from '../toast-notify';

function changeQuantity() {
	$('.quantity-container select').change(function () {
		var quantity = $(this).find('option:selected').val();

		$('.option-quantity-desired input').val(quantity);
		$(this).closest('form').find('.update-item').click();
	});
}

function addItemToBag() {
	$(document).on('click', 'button.add-all-to-cart', function (e) {
		e.preventDefault();

		$(document).find('button[name$="_addToCart"]').each(function (e) {
			$(this).click();
		});
	});

	$(document).on('click', 'button[name$="_addToCart"]', function (e) {
		e.preventDefault();

		var $form = $(this).closest('form');
		var divError = $form.find('div.product-error');

		$.ajax({
			type: 'POST',
			url: util.ajaxUrl(Urls.wishlistAddToCart),
			data: $form.serialize(),
			success: function (response) {
				if (response.error) {
					divError.html(response.error);
				} else {
					minicart.show(response);
				}
			}
		});
	});
}
var wishlistProducts = window.User.wishlistProducts;
var favouriteContents = window.User.FevouriteContents;
// PLP wishlist heart icon

$(document).on('click', '.wishlist-icon', function (e) {
	e.preventDefault();
	e.stopPropagation();

	let ajaxUrl;
	const $this = $(this);
	const currProductID = $this.attr('data-element-pid');
	let productInwishlist, data;
	const isnewaccountpage = $('.account-content_new').length > 0 ? true : false;

	if (currProductID) {
		productInwishlist = $this.attr('data-item-in-wishlist');
		data = {
			pid: currProductID
		};
	} else {
		var currArticleID = $this.attr('data-element-cid');
		data = {
			aid: currArticleID
		};
	}

	if ($this.hasClass("wishlist-added")) {
		ajaxUrl = $this.attr('data-ajax-remove');
	} else {
		ajaxUrl = $this.attr('data-ajax-add');
	}

	if (window.pageContext.ns === 'orderconfirmation') {
		ajaxUrl = util.appendParamToURL(ajaxUrl, 'page', 'confirmation');
	}

	if (isnewaccountpage) {
		// For account redesign
		ajaxUrl = util.appendParamToURL(ajaxUrl, 'isSrcAccount', `${isnewaccountpage}`);
	}

	ajaxUrl = util.appendParamToURL(ajaxUrl, 'format', 'ajax');

	$.ajax({
		type: 'GET',
		url: ajaxUrl,
		data: data
	})
	.done(function (response) {
		const $loginWrapper = $('#login-wrapper-new'); // Variable for reuse

		if (isnewaccountpage) {
			// For account redesign
			$('.wishlist-section-content').html(response);
			$('.empty-wishlist-wrapper').length > 0 && $('.wishlist-section-content, .wishlist-section-header+.divider').removeClass('saved-wishlist').addClass('no-saved-wishlist');
			toast.init(NOTIFICATION_SUCCESS_FAVORITE_PRODUCT, 'active animate__fadeInDownToast', 'hidden');
			search.updateIntersectionObserver();
		}

		if (response && response.error === undefined && response.url === undefined) {
			quickShopHide();
			$('.signin-anchor').trigger('click');
			$loginWrapper.find('form[id$="dwfrm_login"]').addClass('wishlist-login').attr('data-pid', currProductID);
			login.wishlistAjaxLogin('.wishlist-login');
			$loginWrapper.find('.login-close').click(function () {
				$this.removeClass('wishlist-added');
			});
		} else {
			if (currProductID) {
				if (wishlistProducts === null) {
					window.location.reload();
					quickShopHide();
				} else {
					if ($this.hasClass('wishlist-added')) {
						wishlistProducts = arrayRemove(wishlistProducts, $this.attr('data-element-pid'));
					} else {
						wishlistProducts.push($this.attr('data-element-pid'));
					}
					window.User.wishlistProducts = wishlistProducts;
				}
			} else {
				if (favouriteContents === null) {
					window.location.reload();
					quickShopHide();
				} else {
					if ($this.hasClass('wishlist-added')) {
						favouriteContents = arrayRemove(favouriteContents, $this.attr('data-element-cid'));
					} else {
						favouriteContents.push($this.attr('data-element-cid'));
					}
				}
			}
		}
		
	});
});

// Quick shop functionality
function quickShopHide() {
	$('.quick-shop-panel').hide();
	$('html').removeClass('filter-open').removeClass('modal-open');
}

//Wishlist Favourite article heart icon
function arrayRemove(arr, value) {
	return arr.filter(function (ele) {
		return ele != value;
	});
}

function checkWhishlistProductHandler(wishlistProd) {
	$(".wishlist-icon").each(function () {
		var $this = $(this);
		var currEle = $this.attr('data-element-pid');
		$this.removeClass("wishlist-added");
		if (wishlistProd != null && wishlistProd.indexOf(currEle) >= 0) {
			$this.addClass("wishlist-added");
		}
	});
}

function checkFavouriteContents(favouriteContents) {
	$(".ginza-edit-tile .wishlist-icon, .article-tile .wishlist-icon, .article-full-col .wishlist-icon, .article-description-section .wishlist-icon, .article.ginza-type .wishlist-icon").each(function () {
		var $this = $(this);
		var currEle = $this.attr('data-element-cid');
		$this.removeClass("wishlist-added");
		if (favouriteContents != null && favouriteContents.indexOf(currEle) >= 0) {
			$this.addClass("wishlist-added");
		}
	});
}

window.onload = function  () {
	checkWhishlistProductHandler(window.User.wishlistProducts);
	checkFavouriteContents(window.User.FevouriteContents);
	productTile.init();
};

$(document).ajaxComplete(function () {
	checkWhishlistProductHandler(wishlistProducts);
	checkFavouriteContents(favouriteContents);
	productTile.init();
});

export const checkWhishlistProduct = checkWhishlistProductHandler;

export default {
	init : function () {
		addProductToCart();
		changeQuantity();
		addItemToBag();

		$('#editAddress').on('change', function () {
			page.redirect(util.appendParamToURL(Urls.wishlistAddress, 'AddressID', $(this).val()));
		});

		//add js logic to remove the , from the qty feild to pass regex expression on client side
		$('.option-quantity-desired input').on('focusout', function () {
			$(this).val($(this).val().replace(',', ''));
		});
		login.init();
		account.initMobileMenu();
	},
	checkWhishlistProduct
};

